import { ContactState } from '../../../@types/state-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Contacts } from '../../../@types/types'

export const initialState: ContactState = {
  contacts: [],
}

const contactFeatureSlice = createSlice({
  name: 'contactFeature',
  initialState,
  reducers: {
    getContactsLoadSuccess(state, action: PayloadAction<{ contacts: Contacts }>) {
      state.contacts = action.payload.contacts
    },
  },
})

export const { getContactsLoadSuccess } = contactFeatureSlice.actions
export default contactFeatureSlice.reducer
